import styled from 'styled-components'

export const AutoSaveIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`

export const AutoSaveIconText = styled.div`
  margin-left: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
`
